export default {
  "Studies available": "الدراسات المتاحة",
  "Studies limit about":
    "عدد الدراسات التي يمكن معالجتها محدود. لزيادة الحد، يرجى الاتصال بمديرك أو على sales@3opinion.ai",
  "Studies limit reached":
    "تم الوصول إلى الحد الأقصى لمعالجة الدراسات. لزيادته، تواصل مع مديرك أو عبر sales@3opinion.ai",
  "Wait for upload": "يرجى انتظار انتهاء التحميل الحالي",
  Upload: "تحميل",
  directory: "تحميل مجلد",
  zip: "تحميل ملفات",
  gender: "الجنس،\n العمر",
  Name: "الاسم",
  Status: "حالة المعالجة",
  studyDate: "تاريخ الدراسة",
  uploadDate: "تاريخ التحميل",
  "Dicom count": "الصور",
  Action: "الإجراء",
  Delete: "حذف",
  "Delete confirm": "هل أنت متأكد أنك تريد حذف الدراسة؟",
  "Delete confirm about": "عند الحذف، لن يتغير الحد الأقصى لمعالجة الدراسات",
  "No studies": "لا توجد دراسات",
  Search: "بحث",
  Cancel: "إلغاء",
  "Study status none": "غير مبدوءة",
  "Study status proccess": "قيد المعالجة",
  "Study status not_found": "لم يتم العثور على أمراض",
  "Study status found": "تم العثور على أمراض",
  Wait: "انتظار",
  "Zip processed": "جارٍ الضغط",
  Done: "تم",
  "Success upload": "تم تحميل الملفات بنجاح. انتظر تحديث قائمة الدراسات",
  "Upload error": "الخادم غير متاح، حاول مرة أخرى لاحقًا",
  "Reach files size":
    "التحميل غير ممكن. تم تجاوز الحجم الكلي المسموح به للملفات",
  "Upload process": "جارٍ المعالجة",
  Yes: "نعم",
  No: "لا",
  "Study in queue": "في الانتظار",
  "Study in proccess": "قيد المعالجة",
  "Study not found": "لم يتم العثور على أمراض",
  "Study found": "تم العثور على أمراض",
  "Study error": "خطأ في المعالجة",
  "Study error about": "خطأ في التحميل، حاول تحميل الدراسة مرة أخرى",
  patientID: "معرف المريض",
  male_short: "ذ",
  female_short: "أ",
  "Wait for anonimization": "إخفاء الهوية",
  "Wait for loading": "جارٍ التحميل",
  "Studies title": "قائمة الدراسات | " + process.env.VUE_APP_INSTALL_NAME,
  "Error upload": "تنسيق الملفات التي تم تحميلها لا يتوافق مع المتطلبات",
  undefined__error: "تنسيق الملفات غير متوافق",
  good: "جيد",
  step0:
    "يمكنك تحميل مجلد يحتوي على دراسات، سيتم إخفاء الهوية ومعالجتها بواسطة الذكاء الاصطناعي",
  step1:
    "جارٍ تحميل دراساتك، <br> قد يستغرق ذلك بضع دقائق. <br><br> يمكن تصفح دراسات أخرى أثناء التحميل.",
  step2:
    "ستظهر هنا الدراسة التي تم تحليلها بالذكاء الاصطناعي. <br><br> تستغرق المعالجة بضع دقائق وتتم في الخلفية.",
  "Demo Upload text": "ستتمكن من معالجة دراساتك بعد التسجيل",
  Register: "تسجيل",
  "Demo Banner Text":
    "أنشئ حسابًا للحصول على وصول كامل إلى خدمات الذكاء الاصطناعي والدورات التعليمية",
  Okay: "حسنًا",
  "Mobile Notification":
    "عند تصفح الموقع من الهاتف، تكون الوظائف محدودة.<br> للحصول على وظائف كاملة، افتح الموقع من جهاز كمبيوتر.",
  "Studies limit Demo about":
    "ستتمكن من معالجة دراساتك بعد التسجيل في حسابك الشخصي",
  "Dicom count v2": "مقاطع",
  prev: "السابق",
  next: "التالي",
  "Files select": "الملفات المحددة",
  "Access files": "تتوافق مع متطلبات الخدمة",
  "Access files about": "يتم تحميلها إلى الخادم لتحليل الذكاء الاصطناعي",
  "Skip files": "غير متوافقة",
  "Tags values": "قيم الوسوم",
  "Skip files about": "لا تتوافق مع متطلبات الخدمة",
  Check: "تحقق",
  "Status short": "الحالة",
  More: "المزيد",
  TagError: {
    tail: "<br><br> اختر دراسة أخرى أو <a target='_blank' class='demo__underline demo__color--white' href='https://t.me/thirdopinion_support_bot'>اتصل بالدعم الفني</a>",
    not_exist: "لم يتم تحديد <TAG> للدراسة",
    some_error: "<TAG> للدراسة <TAG_VALUE> لا يتوافق مع متطلبات الخدمة <RULES>",
    PatientsAge: "عمر المريض أقل من 18 عامًا",
    Modality: "النمط",
    SliceThickness: "سُمك المقطع",
    BodyPartExamined: "الجزء المفحوص",
    StudyInstanceUID: "معرّف الدراسة",
    SeriesInstanceUID: "معرّف السلسلة",
  },
};
